import React, { useState } from "react";
import ErrorMessage from "./shared/ErrorMessage";
import SharedButton from "./shared/SharedButton";
import SharedInput from "./shared/SharedInput";
import dwlLogo from '../images/dwl_logo_login.png';
import { Link } from "react-router-dom";

const initLoginValues = {
  username: "",
  password: "",
};

const Login = ({ loginSubmit, handleRequestClick, errorUser }) => {
  const [loginVal, setLoginVal] = useState(initLoginValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginVal({
      ...loginVal,
      [name]: value,
    });
  };

  const handleLoginClick = () => {
    const { username, password } = loginVal;
    loginSubmit(username, password);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLoginClick();
    }
  };

  return (
    <div id="loginBox" className="login-box">
      <div className="login-content">
        <img
          src={dwlLogo}
          alt="dwl logo"
          className="img-fluid dwl-login-logo"
        />
        <div className="login-text">
          Instantly access historical price information for thousands of markets
        </div>
        <div id="loginForm" className="login-form">
          <div className="vd_input-wrapper">
            <label htmlFor="username">Username</label>
            <div className="input-with-icon">
              <span className="menu-icon">
                <i className="fa fa-user"></i>
              </span>
              <SharedInput
                id="username"
                name="Username"
                inputType="text"
                inputChange={handleInputChange}
                value={loginVal.username}
              />
            </div>
          </div>
          <div className="vd_input-wrapper">
            <label htmlFor="username">Password</label>
            <div className="input-with-icon">
              <span className="menu-icon">
                <i className="fa fa-lock"></i>
              </span>
              <SharedInput
                id="password"
                name="Password"
                inputType="password"
                inputChange={handleInputChange}
                value={loginVal.password}
                keypress={handleKeyPress}
              />
            </div>
          </div>

          <div className="form-group login-buttons">
            <SharedButton
              id="request-btn"
              addClass="btn-white"
              btnName="REQUEST ACCESS"
              handleClick={handleRequestClick}
            />
            <SharedButton
              id="login-btn"
              addClass="btn-purple"
              btnName="LOGIN"
              handleClick={handleLoginClick}
            />
          </div>
          <ErrorMessage
            id="loginError"
            errorClass={`login-error ${errorUser ? "" : "d-none"}`}
            message="The username or password is incorrect."
          />
          <div className="forget-pass">
            <Link to='/resetpass/' className="forgot-text">Forgot Password</Link>
          </div>
          <div className="contact-us">
            Need help booking a reservation?
            <div className="contact-link">
              <a
                href="https://dwellworksliving.com/Default/ContactUs"
                target="_blank"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
